import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MeuPlanoPageRoutingModule } from './meu-plano-routing.module';

import { MeuPlanoPage } from './meu-plano.page';
import { AssinaturaModule } from '../assinatura/assinatura.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        AssinaturaModule,
        MeuPlanoPageRoutingModule,
        MeuPlanoPage
    ]
})
export class MeuPlanoPageModule {}
